<template>
    <a-card :bordered="false" :loading="loading.page" v-if="loading.page">
      Loading
    </a-card>
    <div v-else>
      <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-card :loading="loading.page" class="margin-bottom">
              
              <div slot="title">
                <h4 class="margin-remove">Reminder Manifest</h4>
                <small>{{ data_header ? data_header.no_reminder_ap : null }}</small>
              </div>

              <!-- header section -->
              <a-popover v-if="actor == 'Creator'" slot="extra" trigger="click" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <li v-if="getAuth.username == data_header.tlc_create">
                    <a-button-group style="display: flex;">
                      <a-button
                      :disabled="data_header.last_status !== 'Revised'"
                      style="width: 100%;"
                      type="dashed"
                      icon="edit"
                      @click="navigateTo('kewajiban_edit')"
                      >Edit</a-button>
                      <!-- <a-button
                        type="danger"
                        icon="close-square"
                        >Cancel</a-button
                      > -->
                    </a-button-group>
                  </li>
                </ul>
                <a-button icon="more">Action</a-button>
              </a-popover>

              <!-- content section -->
              <div class="m-card-body">
                <a-row>
                  <a-col span="12">
                    <ul class="m-list-wrapper bordered">
                      <li>
                        <span class="m-list-title" for>Date / TLC</span>
                        <span class="m-list-desc">{{ moment(data_header.create_dt).format("DD-MM-YYYY") + ' / ' + data_header.tlc_create }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" for>Tanggal Kewajiban</span>
                        <span class="m-list-desc">{{ moment(data_header.tanggal_kewajiban).format("DD-MM-YYYY") }}</span>
                      </li>
                      
                      <li>
                        <span class="m-list-title" for>Description</span>
                        <span class="m-list-desc">{{ data_header.description }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" for>Nilai</span>
                        <span class="m-list-desc">{{ customFormatCurrency(data_header.currency, data_header.nilai) }}</span>
                      </li>
                      <li>
                        <span class="m-list-title" for>Jenis Kewajiban</span>
                        <span class="m-list-desc">{{ data_header.jenis_kewajiban }}</span>
                      </li>
                      <li>
                        <span class="m-list-title" for>Catatan</span>
                        <span class="m-list-desc">{{ data_header.catatan }}</span>
                      </li>
                    </ul>
                  </a-col>
                  <a-col sapn="12">
                    <ul class="m-list-wrapper bordered">
                      <li>
                        <span class="m-list-title" for>Nilai Kurs IDR</span>
                        <span class="m-list-desc">{{ customFormatCurrency('IDR', data_header.kurs_idr) }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" for>Beneficiary</span>
                        <span class="m-list-desc">{{ data_header.beneficiary }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" for>Cost Center</span>
                        <span class="m-list-desc">{{ data_header.cost_center_kode }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" for>Item Anggaran</span>
                        <span class="m-list-desc">{{ data_header.kode_anggaran }} - {{ data_header.item_anggaran }}</span>
                      </li>

                      <li v-if="data_header.user_cc && data_header.no_cc">
                        <span class="m-list-title" for>User CC / No CC</span>
                        <span class="m-list-desc">{{ data_header.user_cc }} / {{ data_header.no_cc }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" for>Notifikasi Sebelum Jatuh Tempo (Hari)</span>
                        <span class="m-list-desc">{{ data_header.reminder_day }}</span>
                      </li>

                    </ul>
                  </a-col>
                </a-row>
              </div>
            </a-card>

            <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Detail Kewajiban</h4>

                <a-card>
                  <a-input-search
                    v-model="search_detail"
                    style="width: 50%"
                    placeholder="Quick Search"
                    allowClear
                  />
                </a-card>

                <a-card>
                  <a-table
                    :columns="columns_detail"
                    :dataSource="filteredDataDetails"
                    :pagination="pagination"
                    size="small"
                    bordered
                  >
                    <template slot="no" slot-scope="text, item, index">
                      {{ index +1 }}
                    </template>
                    <template slot="no_detail" slot-scope="text, item">
                      {{ item.no_rencana_byr }}
                    </template>

                    <template slot="item_name" slot-scope="text, item">
                      <p>
                        {{ item.nama_item }}
                        <span
                          v-if="item.type_tax !== 'non_tax'"
                          class="tax-label"
                        >
                          - ({{ findTax(item.type_tax) }})
                        </span>
                      </p>
                    </template>

                    <template slot="payment_date" slot-scope="text, item">
                      {{ moment(item.tanggal_byr).format("YYYY-MM-DD") }}
                    </template>

                    <template slot="payment_value" slot-scope="text, item">
                      {{ customFormatCurrency(data_header.currency, item.nilai_bayar) }}
                    </template>
                  </a-table>
                </a-card>

                <div class="table-footer">
                  <a-divider />
                  <div class="footer-row footer-grand">
                    <span class="footer-label">Grand Total</span>
                    <span class="footer-separator">:</span>
                    <span class="footer-value">
                      {{ customFormatCurrency(data_header.currency, total_payment + total_tax) }}
                    </span>
                  </div>
                </div>

              </a-collapse-panel>
            </a-collapse>
          </a-col>

        </a-row>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  props: ['id'],
  mixins: [CurrencyFormat],
  data(){
    const columns_detail = [
      {
        title: "No.",
        key: "no",
        width: 60,
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "No. Detail",
        key: "no_detail",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "no_detail" },
      },
      {
        title: "Nama Item",
        key: "item_name",
        // width: 180,
        dataIndex: "nama_item",
        scopedSlots: { customRender: "item_name" },
      },
      {
        title: "Tanggal Bayar",
        key: "payment_date",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "payment_date" },
      },
      {
        title: "Nilai Bayar",
        key: "payment_value",
        // width: 180,
        align: "right",
        scopedSlots: { customRender: "payment_value" },
      },
    ];

    return {
      moment,
      loading: {
          page: false,
          doc: false,
          approval: false
      },
      data_header: {},
      data_details: [],
      data_statuses: [],
      data_actions: [],
      data_taxes: [],
      pagination: {},
      columns_detail,
      actor: "",
      modal_tax: false,
      search_detail: ""
    }
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getType_tax",
    ]),

    files() {
      try {
        return JSON.parse(this.data_header.files || '[]')
      } catch (error) {
        return []
      }
    },

    filteredDataDetails() {
      if (!this.search_detail) return this.data_details;

      const keyword = this.search_detail.toLowerCase().trim();

      return this.data_details.filter(item => {
        return (
          String(item.no_rencana_byr || '').toLowerCase().includes(keyword) ||
          String(item.nama_item || '').toLowerCase().includes(keyword) ||
          String(item.type_tax || '').toLowerCase().includes(keyword) ||
          String(item.tanggal_byr || '').toLowerCase().includes(keyword)
        );
      });
    },

    total_payment(){
      return this.data_details.reduce((total, item) => {
        if(item.type_tax == 'non_tax'){
          return total + Number(item.nilai_bayar || 0)
        }
        return total;
      }, 0)
    },

    total_tax(){
      return this.data_details.reduce((total, item) => {
        const type = String(item.type_tax || '').toLowerCase();

        if(type.includes('ppn')){
          return total + Number(item.nilai_bayar || 0)
        }
        return total;
      }, 0)
    },

    total_pph() {
      return this.data_details.reduce((total, item) => {
        const type = String(item.type_tax || '').toLowerCase();

        if (!type.includes('ppn') && type !== 'non_tax') {
          return total + Number(item.nilai_bayar || 0);
        }

        return total;
      }, 0);
    },
  },

  beforeCreate(){
    this.form = this.$form.createForm(this);
  },
  
  created(){
    this.fetchData()
    this.$store.dispatch("Fetch_TYPE_TAX");
  },

  mounted(){
  },

  methods: {
    async fetchData(){
      try {
        this.loading.page = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `reminder/manifest`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: {
            manifest_id: this.id
          }
        })

        if(response.data){
          this.data_header = response.data.data
          this.data_details = response.data.detail
        }
        this.loading.page = false

      } catch (error) {
        this.loading.page = false
        console.log(error);
        
      }
    },

    async fileHandler(id, fileName){
      try {
        this.loading.doc = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `kewajiban/file/${id}`,
          responseType: "blob",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          }
        })

        this.loading.doc = false

        const blob = response.data;
        const mimeType = blob.type;
        const url = window.URL.createObjectURL(blob);

        // PDF atau gambar -> buka tab baru
        if (
          mimeType === "application/pdf" ||
          mimeType.startsWith("image/")
        ) {
          window.open(url, "_blank");
          return;
        }

        const link = document.createElement("a");
        link.href = url;

        const disposition = response.headers["content-disposition"];
        let filename = fileName;

        if (disposition) {
          const match = disposition.match(/filename="?(.+?)"?$/);
          if (match) {
            filename = match[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.log(error);
        this.loading.doc = false
        
      }
    },

    approval(){
      this.loading.approval = true
      this.form.validateFields(async (err, values) => {
        if(err){
          this.loading.approval = false
          return
        }

        try {
          const payload = {
            note: values.note ? values.note : "",
            manifest_id: this.id,
            status: values.status
          }

          const response = await axios({
              method: "POST",
              url: this.$serviceUrl + `kewajiban/approval`,
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "X-API-KEY": this.getAuth.apikey,
              },
              data: payload
            })
            this.displayMessageValue("success-other", response.data.message);
            this.fetchData()
            this.loading.approval = false
        } catch (error) {
          this.loading.approval = false
          console.log(error);
          
        }
      })
    },

    historyToggle(e) {
      e.stopPropagation();
    },

    showModalTax(){
      this.modal_tax = true
    },

    modalOnClose(){
      this.modal_tax = false
    },

    navigateTo(name){
      this.$router.push({
        name: name,
        params: {
          id: this.id
        }
      })
    },

    findTax(item){
      const find = this.getType_tax.find((e) => e.value == item);
      return find.text
    }

  }
}
</script>

<style>
.tax-label {
  font-weight: bold;
  font-style: italic;
}

.footer-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.footer-row:last-child {
  margin-bottom: 0;
}

.footer-label {
  width: 120px; /* Biar ":" sejajar */
  font-weight: 600;
}

.footer-separator {
  width: 20px;
  text-align: center;
}

.footer-value {
  flex: 1;
  text-align: right; /* Mentok kanan */
  font-weight: 600;
}
</style>